export default __webpack_public_path__ + "static/media/ELEMENTOS_04.83e2a653.png";